import getStore from 'services/getStore';
import { focusBlockAction } from 'store/next';

let delayUpdate;

export default block => {
  // clearTimeout(delayUpdate);
  // delayUpdate = setTimeout(() => {
  //   // getStore().dispatch(focusBlockAction(block));
  //   console.log('FOCUS');
  // }, 1000 / 60);

  getStore().dispatch(focusBlockAction(block));
};
